export default "__VITE_ASSET__Bf4uU44s__"